var _path, _path2, _rect, _path3, _path4, _path5, _path6, _path7, _polygon, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEcommerce(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M456,132.89l-2.69-4.38c-22.67-36.89-63.67-59.13-106.88-56.43a114.08,114.08,0,0,0-16.55,2.24c-39.29,8.31-73.48,37.65-87.65,75.23-8.34,22.1-10.67,47.54-26.48,65.08-20.59,22.84-55.54,23.55-86.26,22.61S63.81,237.1,43.33,260c-12.83,14.35-16.91,34.77-15.87,54,2.74,50.9,38.65,96.4,84.33,119s99.45,24.65,149.44,14.7c70-13.94,136.62-52.22,176.65-111.35S488,196.7,456,132.89Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screen--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M418.6,65.58h-29a7.19,7.19,0,0,0-7,7.36v5.26a7.19,7.19,0,0,1-7,7.36l-56.55,0a7.23,7.23,0,0,1-7.05-7.37V72.88a7.22,7.22,0,0,0-7-7.36h-10.2l-25.39,0a22.85,22.85,0,0,0-22.85,22.83l-.07,366.17a22.83,22.83,0,0,0,22.82,22.83l149.34.09a22.82,22.82,0,0,0,22.84-22.82l.07-366.18A22.83,22.83,0,0,0,418.6,65.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.6,65.58s.26,0,.78,0a15.43,15.43,0,0,1,2.31.17,21.64,21.64,0,0,1,8.57,3,22.23,22.23,0,0,1,5.2,4.22,22.63,22.63,0,0,1,4.35,6.82,23.64,23.64,0,0,1,1.71,9.27c0,3.37,0,7,0,10.76,0,30.42.05,74.43.08,128.8s0,119.14,0,191v34.22a24.17,24.17,0,0,1-.87,7,23.1,23.1,0,0,1-2.92,6.44,24.8,24.8,0,0,1-4.75,5.27,23.16,23.16,0,0,1-13.19,5.12c-4.78.14-9.54,0-14.34.06H376.49l-59.67,0H270.89A24.2,24.2,0,0,1,256,473.54a23.4,23.4,0,0,1-9-12.5,25.28,25.28,0,0,1-.95-7.72v-7.7q0-15.36,0-30.53,0-30.3,0-59.68c0-39.13,0-76.87,0-112.83s0-70.12,0-102.1q0-24,0-46.26c0-1.86,0-3.71,0-5.54,0-.92.08-1.85.13-2.77s.23-1.83.46-2.72a23.36,23.36,0,0,1,4.81-9.68,23.17,23.17,0,0,1,18.61-8.24l19.9,0h14.26a7.33,7.33,0,0,1,4.5,1.25,7.61,7.61,0,0,1,2.79,3.67,12,12,0,0,1,.46,4.51V77a17.39,17.39,0,0,0,.07,2.18A7.21,7.21,0,0,0,313.87,83a6.72,6.72,0,0,0,3.49,2.16,7.76,7.76,0,0,0,2.05.21h10.35l30.1,0,13.27,0c1.05,0,2.12,0,3.11,0a6.8,6.8,0,0,0,2.79-1,7.23,7.23,0,0,0,3.2-4.6,12.35,12.35,0,0,0,.18-2.78c0-.92,0-1.83,0-2.73a14.77,14.77,0,0,1,.12-2.66,7.55,7.55,0,0,1,.86-2.44A7.22,7.22,0,0,1,387,66a11.49,11.49,0,0,1,4.54-.48l14.81,0,9.1,0,3.11,0-3.11,0-9.1,0-14.81,0c-1.46,0-3-.15-4.46.49a7,7,0,0,0-3.53,3.13,7.74,7.74,0,0,0-.83,2.38,16.12,16.12,0,0,0-.11,2.62c0,.9,0,1.81,0,2.73a13.59,13.59,0,0,1-.18,2.83,7.49,7.49,0,0,1-3.3,4.77,7,7,0,0,1-2.91,1c-1.06.09-2.08,0-3.14,0H319.41a7.93,7.93,0,0,1-2.15-.21,7,7,0,0,1-3.68-2.28,7.63,7.63,0,0,1-1.81-4A16.72,16.72,0,0,1,311.7,77V74.74a11.83,11.83,0,0,0-.45-4.37,7.15,7.15,0,0,0-2.64-3.47,7,7,0,0,0-4.27-1.18H270.18a22.7,22.7,0,0,0-18.25,8.1,22.85,22.85,0,0,0-4.69,9.48c-.23.87-.3,1.77-.46,2.66s-.11,1.8-.12,2.72v5.54q0,22.26,0,46.26c0,32,0,66.15,0,102.1V355.41q0,29.34,0,59.68v38.23a24.53,24.53,0,0,0,.92,7.54,22.8,22.8,0,0,0,8.8,12.15,23.43,23.43,0,0,0,14.5,4h15.42l30.51,0,59.67,0,29.08,0c4.79,0,9.59.08,14.31-.06a22.49,22.49,0,0,0,12.83-5,24,24,0,0,0,4.63-5.13,22.52,22.52,0,0,0,2.84-6.26,23.67,23.67,0,0,0,.85-6.8c0-2.32,0-4.62,0-6.93q0-13.8,0-27.29c0-71.89.07-136.65.1-191s.1-98.38.13-128.8c0-3.8,0-7.39,0-10.76a23.5,23.5,0,0,0-1.67-9.2,22.55,22.55,0,0,0-4.29-6.78,22.68,22.68,0,0,0-13.66-7.22,18.42,18.42,0,0,0-2.3-.21C418.86,65.61,418.6,65.58,418.6,65.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.39,102.56c0,.09-3.78.21-8.43.24s-8.43,0-8.43-.1,3.77-.21,8.43-.25S283.39,102.46,283.39,102.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.42,106.87c0,.1-3.77.21-8.42.25s-8.43,0-8.43-.11,3.77-.21,8.42-.25S283.42,106.77,283.42,106.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.46,111.18c0,.1-3.77.21-8.43.25s-8.43,0-8.43-.11,3.77-.21,8.43-.25S283.46,111.08,283.46,111.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.69,
    y: 384.9,
    width: 75.05,
    height: 75.05,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.88,427.84c-6.11-8.53-19.08-14.37-29.62-12.8-8.54,1.27-16.1,5.24-20.24,13.72a3.85,3.85,0,0,0,3,5.55,175.86,175.86,0,0,0,42.83-.14c2.19-.28,4.8-.89,4.95-3.6A4.33,4.33,0,0,0,329.88,427.84Z",
    style: {
      fill: "#1990FF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M329.88,427.84c-6.11-8.53-19.08-14.37-29.62-12.8-8.54,1.27-16.1,5.24-20.24,13.72",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M296.14,427.41c-.05,0-.49-.39-1.07-1.19a9.66,9.66,0,0,1-1.62-3.54,17.39,17.39,0,0,1-.32-3.86,4.85,4.85,0,0,1,.13-1.59,4.88,4.88,0,0,1,.24,1.58,28.63,28.63,0,0,0,.45,3.75,12.49,12.49,0,0,0,1.42,3.46A6.27,6.27,0,0,1,296.14,427.41Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.19,427c-.15,0,.07-2.42-.25-5.36s-1-5.25-.87-5.3A17.64,17.64,0,0,1,305.19,427Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.55,425.61c-.15-.06.56-1.67.73-3.79s-.22-3.83-.07-3.87a8.46,8.46,0,0,1-.66,7.66Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M303.53,415.44l.08.15h0Z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 263.69,
    y: 142.29,
    width: 75.92,
    height: 113.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.69,
    y: 264.68,
    width: 75.92,
    height: 113.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.84,
    y: 243.19,
    width: 75.92,
    height: 106.26,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.22,
    y: 356.92,
    width: 75.92,
    height: 103.02,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.84,
    y: 142.29,
    width: 75.92,
    height: 94,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.58,176.32v31.55c0,1.38-1.11,2.81-3.15,3.89a19.28,19.28,0,0,1-8.75,1.82h-.05c-7.45,0-11.9-2.94-11.9-5.71V176.26c0-3.08,2.27-6.29,4.55-9.47,1.53-2.12,1.9-5.17,2-7,0-.21,0-.4,0-.58h-.21a1.66,1.66,0,0,1-1.78-1.52v-1.33a1.67,1.67,0,0,1,1.78-1.54h11.19a1.82,1.82,0,0,1,1.64.93,1.4,1.4,0,0,1,.14.61v1.33a1.67,1.67,0,0,1-1.78,1.52H307c0,.18,0,.37,0,.58.07,1.8.44,4.85,2,7,2.28,3.18,4.54,6.39,4.55,9.47Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.58,176.32l0-.32a9.13,9.13,0,0,0-.13-.94,12.24,12.24,0,0,0-1.32-3.4,47.59,47.59,0,0,0-3.23-4.87,13.87,13.87,0,0,1-2-7.55v-.18H307a1.61,1.61,0,0,0,1.8-1.19c0-.4,0-.89,0-1.34a1.23,1.23,0,0,0-.45-1.1,1.78,1.78,0,0,0-1.21-.39h-4.51l-6.44,0a1.78,1.78,0,0,0-1.38.48,1.23,1.23,0,0,0-.32.63,7.18,7.18,0,0,0,0,.82c0,.28,0,.61,0,.84a1.16,1.16,0,0,0,.31.65,1.76,1.76,0,0,0,1.44.51l.23,0v.25a19.37,19.37,0,0,1-.42,3.84,10.51,10.51,0,0,1-1.51,3.72,30.58,30.58,0,0,0-4.13,7,8.62,8.62,0,0,0-.44,2c0,.67,0,1.41,0,2.12v4.34q0,4.4,0,8.92c0,5.3,0,10.48,0,15.48a9.47,9.47,0,0,0,.08,1.8,3.39,3.39,0,0,0,.83,1.49,8.37,8.37,0,0,0,2.9,2,19.42,19.42,0,0,0,6.79,1.39,23.55,23.55,0,0,0,6.6-.59,10.45,10.45,0,0,0,5.38-2.88,3.57,3.57,0,0,0,.7-1.24,4.68,4.68,0,0,0,.12-1.42v-2.9c0-1.9,0-3.72,0-5.46,0-6.93.06-12.54.08-16.46,0-1.92,0-3.42,0-4.48s.05-1.56.05-1.56a12.57,12.57,0,0,1,.06,1.56c0,1.06,0,2.56.05,4.48,0,3.92,0,9.53.08,16.46,0,1.74,0,3.56,0,5.46v2.9a5.11,5.11,0,0,1-.12,1.54,4,4,0,0,1-.78,1.4,10.71,10.71,0,0,1-5.6,3,23.76,23.76,0,0,1-6.73.63,19.88,19.88,0,0,1-7-1.42,8.73,8.73,0,0,1-3.08-2.09,4,4,0,0,1-.95-1.71,9.7,9.7,0,0,1-.1-1.92c0-5,0-10.18,0-15.48q0-4.53,0-8.92v-4.34c0-.73,0-1.41,0-2.16a8.8,8.8,0,0,1,.46-2.12,30.68,30.68,0,0,1,4.21-7.11,13.67,13.67,0,0,0,1.86-7.28l.24.24a2.21,2.21,0,0,1-1.78-.67,1.65,1.65,0,0,1-.43-.9c0-.35,0-.6,0-.9a6.9,6.9,0,0,1,0-.89,1.66,1.66,0,0,1,.45-.87,2.2,2.2,0,0,1,1.7-.62l6.44,0h4.51a2.2,2.2,0,0,1,1.45.49,1.66,1.66,0,0,1,.58,1.39c0,.47,0,.89,0,1.39a1.94,1.94,0,0,1-2.15,1.48l.17-.17a13.55,13.55,0,0,0,1.88,7.4,47.4,47.4,0,0,1,3.18,4.94,11.45,11.45,0,0,1,1.24,3.47,7.1,7.1,0,0,1,.09.95A1.07,1.07,0,0,1,313.58,176.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.41,159.17a47.82,47.82,0,0,1-10,0,47.82,47.82,0,0,1,10,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.58,180.53a3.57,3.57,0,0,0-3.41.15,12.75,12.75,0,0,1-3.28,1.41,6.23,6.23,0,0,1-4-1,25.22,25.22,0,0,0-3.71-2,7.22,7.22,0,0,0-7.45,1.75v27s1.49,4.61,11.95,3.89,9.63-5.34,9.63-5.34Z",
    style: {
      fill: "#1990FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.41,395.25s0,0,0,0v31.29c0,1.38-1.1,2.79-3.14,3.87a19,19,0,0,1-8.69,1.81h0c-7.41,0-11.83-2.93-11.83-5.68V395.29s0,0,0,0,0,0,0-.07c0-3.06,2.26-6.25,4.52-9.4,1.53-2.11,1.89-5.15,2-6.93,0-.21,0-.4,0-.57H376a1.66,1.66,0,0,1-1.77-1.52v-1.32a1.65,1.65,0,0,1,1.77-1.52h11.12a1.8,1.8,0,0,1,1.63.92,1.38,1.38,0,0,1,.13.6v1.32a1.65,1.65,0,0,1-1.76,1.52h-.21c0,.17,0,.36,0,.57.07,1.78.43,4.82,1.95,6.93,2.27,3.15,4.51,6.34,4.53,9.4C393.42,395.21,393.41,395.23,393.41,395.25Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.41,395.25a2.54,2.54,0,0,0,0-.32,8.25,8.25,0,0,0-.12-.94,12.24,12.24,0,0,0-1.31-3.37,45.2,45.2,0,0,0-3.22-4.84,13.8,13.8,0,0,1-2-7.5v-.19l.17,0a1.59,1.59,0,0,0,1.78-1.19c0-.39,0-.88,0-1.33a1.27,1.27,0,0,0-.45-1.09,1.81,1.81,0,0,0-1.2-.39h-4.48l-6.4,0a1.76,1.76,0,0,0-1.37.48,1.19,1.19,0,0,0-.32.63,6.94,6.94,0,0,0,0,.81c0,.27,0,.6,0,.83a1.16,1.16,0,0,0,.31.65,1.74,1.74,0,0,0,1.42.5h.24v.25a19.08,19.08,0,0,1-.42,3.81,10.35,10.35,0,0,1-1.5,3.69,30.21,30.21,0,0,0-4.1,7,8,8,0,0,0-.43,2c0,.66,0,1.4,0,2.1,0,1.42,0,2.86,0,4.32V410c0,5.27,0,10.42,0,15.39a9.3,9.3,0,0,0,.08,1.78,3.45,3.45,0,0,0,.83,1.49,8.42,8.42,0,0,0,2.88,2A19.41,19.41,0,0,0,380.5,432a23.3,23.3,0,0,0,6.56-.59,10.26,10.26,0,0,0,5.34-2.86,3.53,3.53,0,0,0,.7-1.23,4.65,4.65,0,0,0,.11-1.41c0-1,0-1.94,0-2.88,0-1.89,0-3.69,0-5.42,0-6.89.06-12.47.08-16.36,0-1.91,0-3.4.05-4.44s0-1.55,0-1.55a10.11,10.11,0,0,1,.06,1.55c0,1,0,2.53,0,4.44,0,3.89.05,9.47.09,16.36,0,1.73,0,3.53,0,5.42,0,.94,0,1.9,0,2.88a4.79,4.79,0,0,1-.13,1.53,4,4,0,0,1-.77,1.39,10.67,10.67,0,0,1-5.56,3,23.52,23.52,0,0,1-6.69.63,19.7,19.7,0,0,1-6.92-1.41A8.72,8.72,0,0,1,370.5,429a4,4,0,0,1-.94-1.7,9.54,9.54,0,0,1-.1-1.9V396.82c0-.72,0-1.4,0-2.14a8.91,8.91,0,0,1,.46-2.12,30.39,30.39,0,0,1,4.18-7.05,13.69,13.69,0,0,0,1.85-7.23l.23.23a2.2,2.2,0,0,1-1.76-.66,1.57,1.57,0,0,1-.42-.9c0-.34,0-.59,0-.89a6.79,6.79,0,0,1,0-.89,1.7,1.7,0,0,1,.45-.86,2.2,2.2,0,0,1,1.69-.62l6.4,0h4.48a2.15,2.15,0,0,1,1.44.49,1.65,1.65,0,0,1,.58,1.38c0,.47,0,.89,0,1.38a2,2,0,0,1-2.14,1.48l.17-.17a13.5,13.5,0,0,0,1.86,7.34,43.75,43.75,0,0,1,3.16,4.91,11.46,11.46,0,0,1,1.24,3.45,5.48,5.48,0,0,1,.08.94C393.44,395.14,393.43,395.25,393.41,395.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.29,378.2a47.25,47.25,0,0,1-9.9,0,47.25,47.25,0,0,1,9.9,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.42,399.43a3.53,3.53,0,0,0-3.39.14,12.76,12.76,0,0,1-3.25,1.41,6.28,6.28,0,0,1-4-1,24.46,24.46,0,0,0-3.69-2,7.16,7.16,0,0,0-7.39,1.75v26.86s1.47,4.59,11.86,3.87,9.58-5.31,9.58-5.31Z",
    style: {
      fill: "#1990FF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M392.42,399.43a3.53,3.53,0,0,0-3.39.14,12.76,12.76,0,0,1-3.25,1.41,6.28,6.28,0,0,1-4-1,24.46,24.46,0,0,0-3.69-2,7.16,7.16,0,0,0-7.39,1.75v26.86s1.47,4.59,11.86,3.87,9.58-5.31,9.58-5.31Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M409.69,281.54a2.2,2.2,0,0,0-2.1.24c-.15.1-.31.22-.46.34a28.75,28.75,0,0,1-17.56,5.63c-12.29,0-22.47-6.89-24.29-15.89v-1.7a1.23,1.23,0,1,0-2.45,0v4.76a1.21,1.21,0,0,0,.07.33,14.74,14.74,0,0,0-1.31,5.94c0,10.39,11,18.83,24.61,18.83,11.41,0,21-5.93,23.8-14a.22.22,0,0,0,.06-.13,5,5,0,0,0,.53-2.07A2.35,2.35,0,0,0,409.69,281.54Z",
    style: {
      fill: "#1990FF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M364.36,276.5s11.59,26.66,43,8c0,0-8.09,8.4-18.64,10.44C379.16,296.77,365,291.38,364.36,276.5Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M410.55,282.88c-.19.46-.94.59-1.67.28s-1.17-.94-1-1.4.94-.58,1.67-.27S410.75,282.42,410.55,282.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.26,111a.72.72,0,0,1-.25,0l-.71,0-2.63,0-8.83.08h-.07v-.07c-.07-.47-.14-1-.22-1.46-.61-4.28-1.15-8.1-1.51-10.6l.05,0h-3a.85.85,0,0,1-.21,0h.21l.63,0,2.35,0h.05V99c.37,2.49.94,6.31,1.58,10.58.07.5.14,1,.21,1.46l-.08-.07,8.83,0h3.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.46,108.5s0,0,.07,0h.18l.71,0,2.66,0,9.16-.09-.08.07c.26-1.55.55-3.22.84-4.94.15-.89.3-1.77.45-2.6l.08.1-10.8,0h-4.29c-.05,0-.07,0-.07,0h.3l.86,0,3.2,0,10.8-.09h.1l0,.1-.44,2.59c-.3,1.73-.59,3.4-.85,5v.06h-.07l-9.16,0h-3.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413,114.42s0-.11-.07-.3a1.19,1.19,0,0,0-.46-.64,1.21,1.21,0,0,0-1.11-.15,1.17,1.17,0,0,0,0,2.19,1.15,1.15,0,0,0,1.11-.16,1.22,1.22,0,0,0,.45-.64c.06-.19.06-.3.07-.3a.63.63,0,0,1,0,.31,1.29,1.29,0,0,1-.45.73,1.32,1.32,0,0,1-1.23.21,1.31,1.31,0,0,1,0-2.48,1.31,1.31,0,0,1,1.24.2,1.24,1.24,0,0,1,.45.72A.57.57,0,0,1,413,114.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421,114.37s0-.11-.07-.29a1.16,1.16,0,0,0-.46-.64,1.18,1.18,0,0,0-1.11-.15,1.17,1.17,0,1,0,1.12,2,1.31,1.31,0,0,0,.46-.65c.05-.19.05-.3.06-.3a.63.63,0,0,1,0,.31,1.26,1.26,0,0,1-.44.73,1.31,1.31,0,0,1-2.12-1,1.33,1.33,0,0,1,.87-1.25,1.29,1.29,0,0,1,1.23.2,1.17,1.17,0,0,1,.45.72A.57.57,0,0,1,421,114.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 422.84,
    cy: 99.63,
    r: 3.54,
    transform: "translate(-11.5 91.44) rotate(-12.18)",
    style: {
      fill: "#1990FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.28,98.27l0,2.69h-.63l0-2.19h-.54v-.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278.27,
    y: 425.59,
    width: 131.13,
    height: 34.42,
    rx: 13.88,
    style: {
      fill: "#1990FF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 278.27,
    y: 425.59,
    width: 131.13,
    height: 34.42,
    rx: 13.88
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 273.18,
    y: 425.59,
    width: 131.13,
    height: 34.42,
    rx: 13.88,
    style: {
      fill: "#1990FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.8,440.91c0,1.76-1.28,2.83-3.39,2.83h-2v2.47h-1.16v-8.14h3.18C333.52,438.07,334.8,439.14,334.8,440.91Zm-1.16,0c0-1.17-.78-1.83-2.27-1.83h-2v3.65h2C332.86,442.73,333.64,442.07,333.64,440.91Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.29,444.17H337l-.89,2h-1.2l3.69-8.14h1.15l3.69,8.14h-1.22Zm-.41-.93-1.75-4-1.76,4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.24,443.39v2.82h-1.15v-2.84l-3.23-5.3h1.24l2.6,4.29,2.62-4.29h1.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.18,303.41a14.71,14.71,0,0,0-12.39-16.8,1.14,1.14,0,0,0-1.45,1.54,17.76,17.76,0,0,0,13.82,15.68",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.57,330.56c3.71,7.65,9,12.8,15.65,13.05,1.32,0,2.32-.82,3.58-.9a8.14,8.14,0,0,1,2.11.8,3.2,3.2,0,0,0,1.11.25c6.82-.37,12.64-5.17,16.56-13.2,5.45-11.25,3.77-23.33-3.76-27a18,18,0,0,0-3.09-1.2,12.18,12.18,0,0,0-3.74-.44,27.83,27.83,0,0,0-8.56,1.93l-.37.14c-6.12-2.71-11-2.72-15.75-.43C279.78,307.23,278.11,319.31,283.57,330.56Z",
    style: {
      fill: "#1990FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.7,319.17a6,6,0,0,1-.62-2.26,12.15,12.15,0,0,1,3.82-10.34,5.67,5.67,0,0,1,1.94-1.31c.05.07-.7.56-1.69,1.57a13.29,13.29,0,0,0-3.71,10C283.54,318.28,283.79,319.14,283.7,319.17Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.08,324.51c-.14,0-.38-.5-.54-1.18s-.17-1.27,0-1.31.38.5.54,1.19S285.22,324.48,285.08,324.51Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.75,285c0,.1-1.42.64-3.54,1.91a29.67,29.67,0,0,0-3.53,2.51A30.94,30.94,0,0,0,309,293.2a30.57,30.57,0,0,0-3,4.4,28.91,28.91,0,0,0-1.76,3.95c-.83,2.34-1.07,3.86-1.17,3.84a4.18,4.18,0,0,1,.12-1.08,9.13,9.13,0,0,1,.25-1.25,16.41,16.41,0,0,1,.45-1.62,24.63,24.63,0,0,1,1.69-4.07,26.79,26.79,0,0,1,6.8-8.31A25.72,25.72,0,0,1,316,286.6a15.26,15.26,0,0,1,1.51-.76,11,11,0,0,1,1.17-.5A4.83,4.83,0,0,1,319.75,285Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.36,180.35c-6.11-8.52-19.08-14.36-29.62-12.79-8.54,1.27-16.1,5.24-20.24,13.72a3.86,3.86,0,0,0,3,5.55,175.86,175.86,0,0,0,42.83-.14c2.2-.28,4.8-.89,4.95-3.6A4.36,4.36,0,0,0,412.36,180.35Z",
    style: {
      fill: "#1990FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.62,179.93c-.05,0-.49-.39-1.07-1.19a9.74,9.74,0,0,1-1.62-3.54,17.39,17.39,0,0,1-.32-3.86,5.31,5.31,0,0,1,.13-1.6,4.7,4.7,0,0,1,.24,1.58,29,29,0,0,0,.46,3.76,11.9,11.9,0,0,0,1.42,3.46A6.19,6.19,0,0,1,378.62,179.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.68,179.51c-.16,0,.06-2.42-.25-5.36s-1-5.25-.87-5.3a13.53,13.53,0,0,1,1.38,5.24A13.76,13.76,0,0,1,387.68,179.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397,178.13c-.14-.06.56-1.68.73-3.8s-.22-3.83-.07-3.86a8.46,8.46,0,0,1-.66,7.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M386,168l.08.15h0Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M386.09,168.11a9.08,9.08,0,0,0,1.5,10.72A14.67,14.67,0,0,0,386.09,168.11Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M377.39,178.43a14,14,0,0,1-1.7-5.71,8.46,8.46,0,0,0-.38-2.61,6.65,6.65,0,0,0-1.45,4.64,6.75,6.75,0,0,0,2.3,4.55,1.75,1.75,0,0,0,.7.4.67.67,0,0,0,.71-.27C377.75,179.12,377.57,178.74,377.39,178.43Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M397.85,171.26h0a2.73,2.73,0,0,0-.3-1,.9.9,0,0,0-.86-.46c-.47.08-.7.61-.84,1.07a11.78,11.78,0,0,0-.69,6.22c.11.47.42,1,.91,1s.62-.4.79-.73A10.1,10.1,0,0,0,397.85,171.26Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M281.48,235.29v.94h-.69v-.93a3.62,3.62,0,0,1-2.05-.7l.37-.84a3.31,3.31,0,0,0,1.68.63v-1.67c-.93-.23-1.93-.53-1.93-1.7,0-.85.62-1.6,1.93-1.72v-1h.69v.93a3.69,3.69,0,0,1,1.7.51l-.35.85a3.42,3.42,0,0,0-1.35-.45v1.69c.93.22,1.94.52,1.94,1.68C283.42,234.42,282.79,235.15,281.48,235.29Zm-.69-3.59v-1.49c-.59.09-.85.4-.85.76S280.3,231.56,280.79,231.7Zm1.56,1.94c0-.41-.37-.61-.87-.75v1.48C282.09,234.28,282.35,234,282.35,233.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.43,229.36v5.86h-1.09v-4.95H286.1v-.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.93,234.58a1.91,1.91,0,0,1-.19.73l-.43,1.18h-.68l.34-1.29a.63.63,0,0,1-.39-.62.68.68,0,1,1,1.35,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.9,233.42c0,1-.74,1.89-2.32,1.89a3.71,3.71,0,0,1-2.2-.68l.46-.85a2.79,2.79,0,0,0,1.73.58c.77,0,1.24-.34,1.24-.9s-.37-.91-1.58-.91h-1.41l.3-3.19h3.44v.91H293l-.13,1.36h.56C295.21,231.63,295.9,232.38,295.9,233.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.53,232.29c0-1.93,1.06-3,2.45-3s2.45,1.09,2.45,3-1.05,3-2.45,3S296.53,234.22,296.53,232.29Zm3.81,0c0-1.42-.56-2.07-1.36-2.07s-1.35.65-1.35,2.07.55,2.07,1.35,2.07S300.34,233.7,300.34,232.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.67,242.69c0,.15-10.75.26-24,.26s-24-.11-24-.26,10.75-.26,24-.26S325.67,242.55,325.67,242.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300,246.6c0,.15-5,.26-11.15.26s-11.16-.11-11.16-.26,5-.26,11.16-.26S300,246.46,300,246.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.65,211.31v.94H365v-.93a3.7,3.7,0,0,1-2-.69l.37-.85a3.19,3.19,0,0,0,1.68.64v-1.68c-.93-.22-1.93-.53-1.93-1.69,0-.85.62-1.6,1.93-1.73v-.94h.69v.93a3.5,3.5,0,0,1,1.7.51l-.35.84a3.42,3.42,0,0,0-1.35-.45v1.69c.93.23,1.94.52,1.94,1.69C367.59,210.44,367,211.18,365.65,211.31Zm-.69-3.58v-1.49c-.6.09-.85.39-.85.76S364.47,207.59,365,207.73Zm1.56,1.93c0-.41-.37-.6-.87-.74v1.48C366.26,210.31,366.52,210,366.52,209.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.82,210.33v.92h-4.33v-.73l2.33-2.21c.57-.55.67-.89.67-1.22,0-.53-.37-.84-1.09-.84a1.65,1.65,0,0,0-1.37.61l-.76-.59a2.7,2.7,0,0,1,2.22-1c1.28,0,2.1.64,2.1,1.68a2.35,2.35,0,0,1-1,1.85l-1.57,1.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.87,210.61a1.92,1.92,0,0,1-.19.72l-.43,1.18h-.68l.34-1.28a.64.64,0,0,1-.4-.62.68.68,0,1,1,1.36,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.91,210.33v.92h-4.33v-.73l2.33-2.21c.57-.55.67-.89.67-1.22,0-.53-.37-.84-1.09-.84a1.65,1.65,0,0,0-1.37.61l-.76-.59a2.7,2.7,0,0,1,2.23-1c1.27,0,2.09.64,2.09,1.68a2.35,2.35,0,0,1-1,1.85l-1.57,1.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.8,209.45c0,1-.74,1.88-2.32,1.88a3.65,3.65,0,0,1-2.2-.68l.46-.84a2.78,2.78,0,0,0,1.72.57c.78,0,1.24-.34,1.24-.89s-.36-.92-1.57-.92h-1.42l.31-3.19h3.44v.92h-2.52l-.13,1.35h.56C386.11,207.65,386.8,208.41,386.8,209.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.84,218.72c0,.14-10.75.26-24,.26s-24-.12-24-.26,10.76-.26,24-.26S409.84,218.58,409.84,218.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.19,222.63c0,.14-5,.26-11.16.26s-11.15-.12-11.15-.26,5-.26,11.15-.26S384.19,222.49,384.19,222.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.56,357v.94h-.69V357a3.65,3.65,0,0,1-2.05-.7l.38-.84a3.18,3.18,0,0,0,1.67.63v-1.67c-.93-.23-1.92-.53-1.92-1.69,0-.86.62-1.6,1.92-1.73v-.95h.69V351a3.69,3.69,0,0,1,1.7.51l-.34.85a3.52,3.52,0,0,0-1.36-.45v1.69c.93.23,1.94.52,1.94,1.68C281.5,356.12,280.88,356.86,279.56,357Zm-.69-3.59v-1.49c-.59.1-.84.4-.84.77S278.39,353.26,278.87,353.4Zm1.56,1.94c0-.41-.37-.6-.87-.75v1.49C280.17,356,280.43,355.7,280.43,355.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.48,354c0-1.93,1.06-3,2.45-3s2.45,1.08,2.45,3-1.05,3-2.45,3S284.48,355.92,284.48,354Zm3.81,0c0-1.41-.56-2.07-1.36-2.07s-1.35.66-1.35,2.07.55,2.07,1.35,2.07S288.29,355.41,288.29,354Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.36,356.29a1.92,1.92,0,0,1-.19.72l-.43,1.18h-.67l.33-1.28a.65.65,0,0,1-.39-.62.68.68,0,1,1,1.35,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.33,355.12c0,1-.74,1.89-2.32,1.89a3.65,3.65,0,0,1-2.2-.68l.46-.85a2.78,2.78,0,0,0,1.72.58c.78,0,1.24-.34,1.24-.9s-.36-.91-1.57-.91h-1.42l.31-3.19H296V352h-2.52l-.13,1.36h.56C295.64,353.33,296.33,354.08,296.33,355.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297,354c0-1.93,1.06-3,2.45-3s2.45,1.08,2.45,3-1.05,3-2.45,3S297,355.92,297,354Zm3.81,0c0-1.41-.56-2.07-1.36-2.07s-1.35.66-1.35,2.07.55,2.07,1.35,2.07S300.77,355.41,300.77,354Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.76,364.4c0,.14-10.76.26-24,.26s-24-.12-24-.26,10.75-.26,24-.26S323.76,364.25,323.76,364.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.1,368.31c0,.14-5,.26-11.15.26s-11.15-.12-11.15-.26,5-.26,11.15-.26S298.1,368.16,298.1,368.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.75,325.26v.94h-.68v-.93a3.66,3.66,0,0,1-2.06-.7l.38-.84a3.19,3.19,0,0,0,1.68.63v-1.67c-.93-.23-1.93-.53-1.93-1.69,0-.86.62-1.6,1.93-1.73v-.95h.68v.93a3.69,3.69,0,0,1,1.7.51l-.34.85a3.46,3.46,0,0,0-1.36-.45v1.69c.93.23,1.94.52,1.94,1.68C363.69,324.39,363.07,325.13,361.75,325.26Zm-.68-3.59v-1.49c-.6.1-.85.4-.85.77S360.58,321.53,361.07,321.67Zm1.55,1.94c0-.41-.37-.6-.87-.75v1.49C362.36,324.25,362.62,324,362.62,323.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.7,319.33v5.86h-1.09v-4.95h-1.24v-.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.21,324.56a1.92,1.92,0,0,1-.19.72l-.43,1.18h-.68l.33-1.28a.65.65,0,0,1-.39-.62.68.68,0,1,1,1.36,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.81,322.26c0-1.93,1.06-3,2.45-3s2.45,1.08,2.45,3-1,3-2.45,3S371.81,324.19,371.81,322.26Zm3.81,0c0-1.41-.56-2.07-1.36-2.07s-1.35.66-1.35,2.07.55,2.07,1.35,2.07S375.62,323.68,375.62,322.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.45,322.26c0-1.93,1.06-3,2.45-3s2.45,1.08,2.45,3-1.05,3-2.45,3S377.45,324.19,377.45,322.26Zm3.81,0c0-1.41-.56-2.07-1.36-2.07s-1.35.66-1.35,2.07.55,2.07,1.35,2.07S381.26,323.68,381.26,322.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406,332.67c0,.14-10.76.26-24,.26s-24-.12-24-.26,10.75-.27,24-.27S406,332.52,406,332.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.29,336.58c0,.14-5,.26-11.15.26s-11.15-.12-11.15-.26,5-.27,11.15-.27S380.29,336.43,380.29,336.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.76,108.53c0,.14-11.59.26-25.88.26s-25.89-.12-25.89-.26,11.59-.26,25.89-.26S369.76,108.38,369.76,108.53Z",
    style: {
      fill: "#1990FF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.6,419.05a6.92,6.92,0,0,0-6.5,5.54A66.68,66.68,0,0,0,24.57,432s-5.87,5.28,0,6.69,8-6.5,8-6.5l.9-13.18Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.38,318s18.34-61.59,20.21-64.24c3.08-4.39,32.77-17.59,32.77-17.59l8-16.24L201.67,212l12.23,15.74L248.27,253l-2.4,87.12-1.28,60.83,6.51,75.94L95,476.6l7.06-16,7.41-138.12Z",
    style: {
      fill: "#1990FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.53,309.69a1.65,1.65,0,0,1-.06-.5c0-.39,0-.86-.08-1.43,0-1.24-.11-3-.15-5.25-.08-4.44-.08-10.57.11-17.34s.55-12.89.89-17.32c.16-2.21.32-4,.45-5.23l.15-1.42a2.76,2.76,0,0,1,.09-.49,1.48,1.48,0,0,1,0,.5c0,.38,0,.85-.06,1.42-.07,1.32-.17,3.09-.29,5.25-.24,4.43-.54,10.54-.73,17.31s-.25,12.88-.26,17.32c0,2.16,0,3.93,0,5.25,0,.57,0,1,0,1.43A1.77,1.77,0,0,1,112.53,309.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M147.89,292a3,3,0,0,1,.57-1.93,5,5,0,0,1,5.83-1.44c2.61,1.25,3.91,4.25,4.44,7.1.57,3.12.49,6.34,1.08,9.46s2,6.3,4.75,7.91c3.39,2,7.84,1.1,11.4,2.78,5.3,2.49,6.53,9.38,6.8,15.24.5,11.09,0,22.19-.46,33.28l-3.06,70.82-2.79,35.53-14.36,6.1L143.09,352Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M152,281.88a1,1,0,0,1-.37.2,2.52,2.52,0,0,1-1.22.12,4.19,4.19,0,0,1-3.26-2.85,7.54,7.54,0,0,1-.29-3.08,33.13,33.13,0,0,1,.58-3.45c.48-2.42,1-5.06,1.56-7.83,1.12-5.55,2.16-10.57,2.94-14.2l1-4.29a10.59,10.59,0,0,1,.41-1.56,8.74,8.74,0,0,1-.21,1.6c-.21,1.11-.47,2.57-.79,4.33-.69,3.64-1.68,8.67-2.8,14.22-.57,2.77-1.11,5.41-1.6,7.82s-1,4.59-.41,6.33a4,4,0,0,0,2.94,2.76A3.48,3.48,0,0,0,152,281.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.06,258.71c0,.05-.41.05-1.09.26a5.07,5.07,0,0,0-2.41,1.7,4.26,4.26,0,0,0-.74,4.1,4.46,4.46,0,0,0,8.27.66,4.25,4.25,0,0,0-.08-4.16,5,5,0,0,0-2.11-2.06c-.64-.32-1-.38-1-.43s.1,0,.29,0a3.06,3.06,0,0,1,.82.23,4.94,4.94,0,0,1,2.35,2.06,5,5,0,0,1,.69,2.09,4.42,4.42,0,0,1-.5,2.48,4.92,4.92,0,0,1-9.16-.73,4.39,4.39,0,0,1-.1-2.53,5.06,5.06,0,0,1,3.65-3.61,3,3,0,0,1,.85-.1A.78.78,0,0,1,157.06,258.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.85 322.38 83.69 306.06 41.6 315.3 135.78 332.25 173.85 322.38",
    style: {
      fill: "#1990FF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "173.85 322.38 83.69 306.06 41.6 315.3 135.78 332.25 173.85 322.38"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M116.2,361.7c1.22-16.62,5.78-58.83,9.2-75.14,1-4.88,2.2-9.87,5-14s7.74-7.15,12.66-6.39c4.4.68,7.94,4.25,9.72,8.33a29.5,29.5,0,0,1,2.27,13.07c-.85,20.16-2.59,42.74-2.57,61.43",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.73,322.12a33.82,33.82,0,0,1-3.34,1.06,67,67,0,0,0-15.33,6.95,33.2,33.2,0,0,1-3,1.82s.23-.25.71-.63,1.19-.89,2.09-1.5a53.25,53.25,0,0,1,7.43-4.12,51.77,51.77,0,0,1,8-2.87c1.05-.28,1.91-.48,2.5-.59A3.66,3.66,0,0,1,146.73,322.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.23,302.94c0,.08-1.35.38-3.51,1.05a47.53,47.53,0,0,0-15.53,8.16c-1.77,1.4-2.8,2.36-2.86,2.3a4.27,4.27,0,0,1,.65-.75c.44-.46,1.11-1.09,2-1.83a40.05,40.05,0,0,1,7.37-5,40.55,40.55,0,0,1,8.29-3.25,25.75,25.75,0,0,1,2.63-.59A3.15,3.15,0,0,1,148.23,302.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.21,287.5c0,.09-1.07.14-2.76.45a24.19,24.19,0,0,0-6.33,2.11,24.47,24.47,0,0,0-5.5,3.78c-1.27,1.16-2,2-2,1.93s.12-.25.41-.64a14.06,14.06,0,0,1,1.35-1.56,21,21,0,0,1,12-6,14.75,14.75,0,0,1,2.06-.14C145.94,287.44,146.2,287.46,146.21,287.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135,335.58a.3.3,0,0,0,0,.09v57.7c0,2.53-2,5.14-5.79,7.12s-9.2,3.33-16,3.34h-.09c-13.65,0-21.81-5.39-21.81-10.46v-57.7a.55.55,0,0,0,0-.09s0-.07,0-.11c0-5.64,4.17-11.53,8.35-17.35,2.8-3.88,3.47-9.48,3.6-12.76,0-.4,0-.75,0-1.07h-.38a3,3,0,0,1-3.25-2.79v-2.44a3,3,0,0,1,3.25-2.81h20.5a3.3,3.3,0,0,1,3,1.71,2.57,2.57,0,0,1,.25,1.1v2.44a3,3,0,0,1-3.26,2.79h-.37c0,.32,0,.67,0,1.07.13,3.28.8,8.88,3.61,12.76,4.17,5.82,8.32,11.71,8.35,17.35C135,335.51,135,335.56,135,335.58Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135,335.58a4.35,4.35,0,0,0,0-.59,14.89,14.89,0,0,0-.21-1.72,22.52,22.52,0,0,0-2.39-6.26,84.45,84.45,0,0,0-5.9-8.95,18.21,18.21,0,0,1-2.68-6.21,33.42,33.42,0,0,1-.92-7.55v-.18h.18a3.8,3.8,0,0,0,2.17-.51,2.6,2.6,0,0,0,1.26-1.81c0-.77,0-1.64,0-2.47a2.49,2.49,0,0,0-.89-2.13,3.42,3.42,0,0,0-2.32-.76H115l-11.81,0a3.4,3.4,0,0,0-2.66.94,2.42,2.42,0,0,0-.64,1.26,15.06,15.06,0,0,0,0,1.53c0,.51,0,1.09,0,1.56a2.43,2.43,0,0,0,.62,1.3,3.4,3.4,0,0,0,2.77,1h.24v.25a34.86,34.86,0,0,1-.76,7A19.25,19.25,0,0,1,100,318c-1.41,2-2.86,4-4.2,6.12a33,33,0,0,0-3.4,6.73,15.26,15.26,0,0,0-.81,3.72c-.07,1.25,0,2.59,0,3.89v24.3c0,9.71,0,19.2,0,28.36a17.47,17.47,0,0,0,.16,3.35,6.58,6.58,0,0,0,1.57,2.82A15.56,15.56,0,0,0,98.69,401a30.43,30.43,0,0,0,6.2,1.85,42.47,42.47,0,0,0,6.31.71,43.05,43.05,0,0,0,12.14-1.11,26.56,26.56,0,0,0,5.49-2,14.08,14.08,0,0,0,4.46-3.35,7,7,0,0,0,1.31-2.34,8.62,8.62,0,0,0,.22-2.65v-5.32c0-3.47,0-6.81,0-10,0-12.72.06-23,.08-30.16s.09-11.06.09-11.06a2.94,2.94,0,0,1,0,.73q0,.75,0,2.13c0,1.89,0,4.65,0,8.2,0,7.14,0,17.44.08,30.16,0,3.18,0,6.52,0,10v6.68a5.6,5.6,0,0,1-.22,1.41,7.28,7.28,0,0,1-1.39,2.49,14.29,14.29,0,0,1-4.59,3.47,27.26,27.26,0,0,1-5.57,2A43.74,43.74,0,0,1,111.18,404a42.23,42.23,0,0,1-6.38-.71,31.25,31.25,0,0,1-6.31-1.88,15.74,15.74,0,0,1-5.56-3.79,6.94,6.94,0,0,1-1.69-3,17,17,0,0,1-.18-3.47V338.48c0-1.32,0-2.6,0-3.93a16,16,0,0,1,.84-3.84,33.26,33.26,0,0,1,3.46-6.84c1.34-2.13,2.81-4.14,4.22-6.13a19,19,0,0,0,2.67-6.56,35.2,35.2,0,0,0,.77-6.88l.23.23a3.87,3.87,0,0,1-3.11-1.15,2.8,2.8,0,0,1-.73-1.55c0-.59,0-1.08,0-1.62a14.72,14.72,0,0,1,0-1.61,2.89,2.89,0,0,1,.77-1.49,3.88,3.88,0,0,1,3-1.08l11.81,0h8.25a3.82,3.82,0,0,1,2.56.86,2.84,2.84,0,0,1,1,2.42c0,.86,0,1.65,0,2.52a2.93,2.93,0,0,1-1.42,2.06,4.09,4.09,0,0,1-2.36.54l.16-.16c.09,5.27,1.11,10.15,3.49,13.61a82.49,82.49,0,0,1,5.84,9,21.68,21.68,0,0,1,2.32,6.33A13.51,13.51,0,0,1,135,335,1.63,1.63,0,0,1,135,335.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.88,304.15a78.41,78.41,0,0,1-9.12.26,78.66,78.66,0,0,1-9.13-.26,81.43,81.43,0,0,1,9.13-.26A81.17,81.17,0,0,1,121.88,304.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.18,343.29c-1.84-1.2-4.27-.67-6.25.27s-3.85,2.25-6,2.59c-2.53.41-5.08-.6-7.33-1.87s-4.38-2.84-6.8-3.71a13.24,13.24,0,0,0-13.64,3.22v49.54s2.72,8.45,21.88,7.13,17.65-9.79,17.65-9.79Z",
    style: {
      fill: "#1990FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.42,309.57a14,14,0,0,0-11.83-16,1.42,1.42,0,0,0-1,.11c-.41.28-.42.87-.38,1.36a17,17,0,0,0,13.2,15",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.75,335.48c3.54,7.3,8.63,12.22,14.94,12.46,1.26,0,2.21-.79,3.41-.86a8,8,0,0,1,2,.76,2.88,2.88,0,0,0,1,.24c6.52-.35,12.07-4.93,15.81-12.6,5.21-10.73,3.6-22.26-3.59-25.77a17.62,17.62,0,0,0-2.94-1.15,12.39,12.39,0,0,0-3.57-.42A27,27,0,0,0,81.71,310l-.35.13c-5.85-2.58-10.51-2.6-15-.41C59.13,313.22,57.53,324.75,62.75,335.48Z",
    style: {
      fill: "#1990FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.87,324.61a5.69,5.69,0,0,1-.6-2.16,11.6,11.6,0,0,1,3.65-9.87,5.63,5.63,0,0,1,1.86-1.25c0,.08-.66.54-1.61,1.51a12.93,12.93,0,0,0-2.77,4.42,12.66,12.66,0,0,0-.76,5.16C62.72,323.76,63,324.58,62.87,324.61Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2,329.71c-.14,0-.38-.47-.53-1.13s-.16-1.21,0-1.24.37.47.53,1.13S64.34,329.68,64.2,329.71Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.28,292c0,.09-1.34.61-3.37,1.83a26.34,26.34,0,0,0-3.36,2.4A29.51,29.51,0,0,0,87,299.83a30,30,0,0,0-2.82,4.2,26.47,26.47,0,0,0-1.68,3.77c-.79,2.22-1,3.68-1.13,3.66a4.64,4.64,0,0,1,.11-1,7.81,7.81,0,0,1,.24-1.19,15.13,15.13,0,0,1,.43-1.56,23.69,23.69,0,0,1,1.61-3.88,25.24,25.24,0,0,1,6.49-7.93,23,23,0,0,1,3.49-2.35c.51-.31,1-.52,1.44-.73a9.14,9.14,0,0,1,1.12-.47A4.39,4.39,0,0,1,97.28,292Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6,315.3,30.27,458.22l105.6,25.53s36.84-12.49,37.34-13.34.64-148,.64-148l-38.07,9.87Z",
    style: {
      fill: "#1990FF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6,315.3,30.27,458.22l105.6,25.53s36.84-12.49,37.34-13.34.64-148,.64-148l-38.07,9.87Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M207.23,148.82l-5.89,83.41A26,26,0,0,1,175.4,256.4h0a26,26,0,0,1-26-27.7c.52-7.94,1-14.45,1-14.45s-20.19-3.14-20.44-23.33c-.14-11.66,1.87-38.12,3.59-58.39A26.48,26.48,0,0,1,160,108.3h12.19A37.37,37.37,0,0,1,207.23,148.82Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.44,214.25s12.73.75,26.29-7.77c0,0-6.5,14.69-26.65,12.87Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.38,153.35c.36.38,2.54-1.24,5.65-1.23s5.37,1.56,5.71,1.18c.16-.17-.2-.84-1.19-1.57a8,8,0,0,0-4.57-1.41,7.74,7.74,0,0,0-4.5,1.45C137.53,152.51,137.21,153.19,137.38,153.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171,156.92a2.9,2.9,0,0,0,2.78,2.91,2.77,2.77,0,0,0,3-2.6,2.88,2.88,0,0,0-2.78-2.91A2.76,2.76,0,0,0,171,156.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.18,156.92a2.89,2.89,0,0,0,2.78,2.91,2.76,2.76,0,0,0,3-2.6,2.87,2.87,0,0,0-2.77-2.91A2.75,2.75,0,0,0,140.18,156.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.57,153.36c.36.37,2.55-1.25,5.65-1.24s5.37,1.56,5.71,1.18c.16-.17-.2-.84-1.19-1.57a8,8,0,0,0-4.57-1.41,7.74,7.74,0,0,0-4.5,1.45C167.72,152.51,167.4,153.19,167.57,153.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.31,176.36c0-.17-1.91-.5-5-.9-.79-.09-1.54-.24-1.67-.78a4,4,0,0,1,.52-2.35l2.35-6c3.25-8.59,5.61-15.65,5.26-15.78s-3.27,6.73-6.52,15.32Q150,169,149,171.9a4.67,4.67,0,0,0-.41,3.11,2,2,0,0,0,1.31,1.16,5.39,5.39,0,0,0,1.34.19C154.35,176.53,156.3,176.54,156.31,176.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.44,178.51c-.5,0-.51,3.34-3.39,5.73s-6.47,2-6.5,2.49c0,.21.8.65,2.32.7a8.41,8.41,0,0,0,5.42-1.89,7.35,7.35,0,0,0,2.63-4.81C166.05,179.33,165.67,178.49,165.44,178.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.77,143.27c.31.84,3.4.44,7,.88s6.59,1.43,7.07.68c.22-.36-.3-1.16-1.48-2a11.88,11.88,0,0,0-5.24-1.83,11.75,11.75,0,0,0-5.51.65C167.31,142.21,166.64,142.87,166.77,143.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.81,144.47c.55.71,2.69,0,5.26-.06s4.74.48,5.25-.26c.21-.36-.13-1.07-1.08-1.73a7.58,7.58,0,0,0-8.46.26C137.87,143.4,137.57,144.13,137.81,144.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.42,164c.35-.15,13.88-4.1,13.44,9.7s-14.21,10.51-14.22,10.12S200.42,164,200.42,164Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204,178.69c.06,0,.24.18.64.38a2.39,2.39,0,0,0,1.79.09c1.48-.49,2.78-2.76,2.92-5.25a7.77,7.77,0,0,0-.56-3.46,2.79,2.79,0,0,0-1.75-1.91,1.22,1.22,0,0,0-1.44.62c-.2.38-.12.66-.19.68s-.29-.24-.16-.81a1.6,1.6,0,0,1,.57-.85,1.82,1.82,0,0,1,1.34-.31,3.41,3.41,0,0,1,2.45,2.22,8.28,8.28,0,0,1,.71,3.88c-.18,2.78-1.69,5.33-3.7,5.85a2.59,2.59,0,0,1-2.19-.44C204,179,204,178.72,204,178.69Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.1,163.5c-2.1-.51-5.74,1.44-6.64,3.41s-1.1,4.2-2,6.17-2.92,3.76-5,3.26a4.24,4.24,0,0,1-2.87-3.15,11.48,11.48,0,0,1,0-4.45c.81-6.45,2.16-12.84,2.42-19.33s-.66-13.24-4.07-18.77-9.67-9.6-16.15-9.08c-4.29.35-8.22,2.59-12.48,3.18a16.84,16.84,0,0,1-14-4.67c-.47-.46-2.62-1.89-2.62-1.89,0-.33.31-3.21,1.45-4.26,8.45-7.82,23.69-10,34.86-7.19s21.64,10.69,26.44,21.16,3.38,25,.73,35.61",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.38,128.89c1.81,4.19,6.43,6.63,11,7.09s9.08-.72,13.47-2,16.18-3.2,20.75-3.06c.68,0,1.5,0,1.87-.57.48-.77-.29-1.7-1-2.25-6-4.72-20.57-7.61-28.21-7.93s-15.65,3-19.79,9.39",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.37,129.41s53-17,75.88,28.79c0,0,3.42-11.47,3.42-17.62,0-4.1-2.45-28.56-27.61-36.25C185.06,104.33,147.15,89.87,133.37,129.41Z",
    style: {
      fill: "#1990FF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M133.37,129.41a24.6,24.6,0,0,1,16.84-7.64c15.63-.7,44.87,8.09,59,36.43,0,0,3.42-11.47,3.42-17.62,0-4.1-2.45-28.56-27.61-36.25C185.06,104.33,147.15,89.87,133.37,129.41Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M207,152.83a99.84,99.84,0,0,0-30.86-29.55C164,115.67,143.87,108.15,130,104.46c-4.16-1.1-8.5-2.07-12.75-1.33s-8.41,3.56-9.46,7.74c-1.32,5.23,8,13.3,12.33,16.47a141.36,141.36,0,0,0,13.26,7.83s-.12-9.7,15.41-11.7C169.9,120.75,207,152.83,207,152.83Z",
    style: {
      fill: "#1990FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.6,113.25s-7.64-4.22-15.3-5.2a19.23,19.23,0,0,1,4.16-2.5,39.57,39.57,0,0,1,11.92,4Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.14,250.84s-14.48,16.55-12.88,39.58c.22,3.19.38,7.64.77,10.82,2.44,19.76,6.22,38.1,6.22,38.1h1.38l50.49-12.47s-7.61-43.83-9.36-49.65C261.17,258.59,242,248.34,242,248.34Z",
    style: {
      fill: "#1990FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.21,470.41s0-.25,0-.74,0-1.24,0-2.2c0-1.94,0-4.78,0-8.45,0-7.37,0-18,.06-31.32.09-26.59.22-63.59.37-105.32l.32.25-19.2,5-18.86,4.89.19-.25c.26,20.92.19,40.66.09,58.5s-.2,33.77-.28,47.09,0,24,0,31.4c0,3.68,0,6.53,0,8.48v2.2c0,.49,0,.74,0,.74s0-.25,0-.74,0-1.24,0-2.2c0-2-.07-4.8-.13-8.48-.09-7.37-.15-18.08-.14-31.4s.11-29.26.17-47.09.12-37.58-.15-58.49v-.21l.2-.05,18.85-4.89,19.21-5,.33-.09v.34c-.22,41.73-.41,78.74-.54,105.32-.09,13.28-.17,23.95-.22,31.32,0,3.67-.06,6.51-.08,8.45,0,1,0,1.69,0,2.2S173.21,470.41,173.21,470.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.83,221.08s-2,19.21,4.46,22.2c7.29,3.36,14.56.07,19-2.78,11.91-7.6,29.61-28.71,29.61-28.71l12,15.58s-30.22,36.32-36.29,36.08c-4-.15-10.15-4-14-6.71a26,26,0,0,1-5.57-5.27l-5.23-6.65c-6.53,3.22-11.81,7.35-15.46,12.64,0,0-1.74-13.45,1.39-19.55s9.37-16.63,9.37-16.63Z",
    style: {
      fill: "#1990FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.37,238.43a1.25,1.25,0,0,1-.12.33c-.09.24-.22.55-.39.94a21,21,0,0,0-.89,3.82,59.75,59.75,0,0,0,0,14.4l-.36-.07a26.55,26.55,0,0,1,6.48-7.38,48.24,48.24,0,0,1,9.58-6.07l.16-.08.12.14c2.11,2.45,4.34,5,6.69,7.59a48.14,48.14,0,0,0,7.89,7.28A19.73,19.73,0,0,0,173,261.7a14.71,14.71,0,0,0,2.4.65,9.82,9.82,0,0,0,2.42.09c3.25-.3,6-2.16,8.28-4.12l0,0,20.69-22.06,6-6.33,1.61-1.67.42-.43.16-.13-.12.16-.4.46-1.55,1.72-5.9,6.43-20.54,22.18h0a22.25,22.25,0,0,1-3.86,2.76,12,12,0,0,1-4.7,1.5,11,11,0,0,1-2.56-.09,14.55,14.55,0,0,1-2.49-.67,20.56,20.56,0,0,1-4.61-2.43,48.36,48.36,0,0,1-8-7.36c-2.36-2.6-4.59-5.16-6.69-7.62l.29.06a48.64,48.64,0,0,0-9.5,6A26.5,26.5,0,0,0,138,258l-.3.52-.06-.59a57.35,57.35,0,0,1,.16-14.48,19.68,19.68,0,0,1,1-3.81c.18-.42.34-.72.44-.93A2.38,2.38,0,0,1,139.37,238.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M140.11,254.62a2.57,2.57,0,0,0,.74,2.93,2.44,2.44,0,0,0,2.49-.45,9.29,9.29,0,0,0,1.68-2.05,21.84,21.84,0,0,1,4.27-4.58c1.61-1.3,3.82-2.4,5.67-1.48a6.4,6.4,0,0,1,2.5,3.19c2.51,5.13,5.52,10.35,10.43,13.28s11.22,3.06,16.63,1.15a32.86,32.86,0,0,0,13.72-10.07,97,97,0,0,0,9.49-14.34c2.26-3.91,4.55-7.94,5.25-12.4-.62.35-2.08,2.6-2.7,2.95,0,0-23.31,25.67-25.5,27s-8.23,10.19-25.34-9l-5.66-6.14S143,249.84,140.11,254.62Z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 176.19,
    y: 307.98,
    width: 25.93,
    height: 7.83,
    transform: "translate(49.45 -25.06) rotate(8.72)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.88,327.84l-40,9.67,4.62,37.73-76.6,57.53c-3.06.43-6.2.92-7.94,1.36-4.19,1-11.59,11.55-13.68,12.6l-14.93,11.52s-1.31,5.24,5.5,4.19,14.4-6.28,15.19-6.28,3.17,1.59,2,5c-1,3-5.1,13.32-5.1,13.32l-5.07,9.3s21.92.72,28-7.41c4.16-5.52,17-21.17,17-21.17s90.17-44.36,95.58-53.65C283.82,388.91,271.88,327.84,271.88,327.84Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.44,391.5a24.91,24.91,0,0,0-.18-4.12,14.36,14.36,0,0,0-13.55-12.26,24.82,24.82,0,0,0-4.12.23,3.81,3.81,0,0,1,1.08-.33,12.73,12.73,0,0,1,3.06-.27,14.22,14.22,0,0,1,13.89,12.58,12.75,12.75,0,0,1,0,3.07A3.82,3.82,0,0,1,253.44,391.5Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.88,469.69a11.5,11.5,0,0,1-.52,2.52,27,27,0,0,1-2.22,5.83,11.62,11.62,0,0,1-4.22,4.61,6.34,6.34,0,0,1-1.77.72,1.51,1.51,0,0,1-.7.07,15.39,15.39,0,0,0,2.28-1.1,12.56,12.56,0,0,0,4-4.55A34.85,34.85,0,0,0,153,472.1,14.76,14.76,0,0,1,153.88,469.69Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.5,466.2a9.93,9.93,0,0,1-.77,2.43,47.9,47.9,0,0,1-2.62,5.58,48.69,48.69,0,0,1-3.32,5.2,10.4,10.4,0,0,1-1.64,2,15.33,15.33,0,0,1,1.34-2.17c.86-1.31,2-3.15,3.16-5.24s2.09-4,2.74-5.47A14.82,14.82,0,0,1,164.5,466.2Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.21,400.9a5.66,5.66,0,0,1,.18,1.28c.09.82.16,2,.2,3.49a68.63,68.63,0,0,1-3.3,22.76c-.46,1.4-.86,2.53-1.18,3.29a6.34,6.34,0,0,1-.53,1.17,5.77,5.77,0,0,1,.34-1.24c.26-.78.61-1.92,1-3.33a82,82,0,0,0,2.44-11.21,83.83,83.83,0,0,0,.84-11.44c0-1.47,0-2.66,0-3.48A6.86,6.86,0,0,1,164.21,400.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.54,412.91a26.69,26.69,0,0,1,1.26,3.15c.74,2,1.77,4.66,3,7.61s2.37,5.6,3.22,7.51a27.5,27.5,0,0,1,1.31,3.13,17.24,17.24,0,0,1-1.64-3c-.94-1.88-2.15-4.51-3.37-7.47s-2.19-5.69-2.84-7.69A18.3,18.3,0,0,1,142.54,412.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.73,438.8a2.62,2.62,0,0,1-.63.18l-1.83.44c-.8.19-1.77.41-2.92.6s-2.44.47-3.9.65-3,.43-4.75.58-3.56.28-5.49.39a104.79,104.79,0,0,1-25.08-1.91c-1.89-.41-3.7-.77-5.36-1.23s-3.21-.86-4.61-1.29-2.66-.86-3.76-1.23-2-.73-2.79-1l-1.75-.7a4.62,4.62,0,0,1-.6-.28,2.48,2.48,0,0,1,.64.18l1.78.61c.76.28,1.71.62,2.81,1s2.36.78,3.77,1.15,2.94.84,4.61,1.22,3.46.79,5.35,1.18a121.38,121.38,0,0,0,12.43,1.66,119.48,119.48,0,0,0,12.54.24c1.93-.1,3.76-.17,5.47-.34s3.29-.33,4.74-.51,2.75-.4,3.9-.58,2.13-.35,2.93-.51l1.85-.34A2.92,2.92,0,0,1,136.73,438.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.92,421.41a26.79,26.79,0,0,1-4.75-2.29,27.71,27.71,0,0,1-4.5-2.74,25.62,25.62,0,0,1,4.75,2.29A26.4,26.4,0,0,1,132.92,421.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.12,326.87l-.25.08-.74.2-2.86.73-10.76,2.66-37.2,9-.27.06,0-.27c-1.05-6.87-2.49-14.28-3.88-22-.91-5.15-1.7-10.2-2.24-15.1s-.78-9.67-.85-14.21a76.75,76.75,0,0,1,.75-12.85,37,37,0,0,1,3.28-10.73,26.88,26.88,0,0,1,5.52-7.43,21.65,21.65,0,0,1,5.77-3.94,19.29,19.29,0,0,1,4.22-1.33l1.14-.14a1.89,1.89,0,0,1,.39,0,1.76,1.76,0,0,1-.39.08l-1.12.2a19.43,19.43,0,0,0-4.15,1.4,22,22,0,0,0-5.66,4,27,27,0,0,0-5.39,7.38,37.1,37.1,0,0,0-3.18,10.63,77.2,77.2,0,0,0-.7,12.79c.08,4.52.34,9.26.88,14.15s1.34,9.93,2.25,15.07c1.38,7.71,2.81,15.13,3.86,22l-.31-.21,37.25-8.85,10.79-2.52,2.88-.65.75-.16A1.19,1.19,0,0,1,276.12,326.87Z",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcommerce);
export default __webpack_public_path__ + "static/media/ecommerce.a1ffa0d0b17481b92010292931501eb2.svg";
export { ForwardRef as ReactComponent };